import { HttpParams } from '@angular/common/http';

import { toHTTPParam, IntervaloSemana } from '../../../core';
import { Filter } from '../../../models';
import { visibilidadeMinhas, visibilidadeCriadasPorMim, visibilidadeTodas } from './visibilidade';
import { tipoEntrarEmContato, tipoVisitar, tipoTarefa, tipoClienteNovo, tipoClientePreInativo, tipoClienteInativo, tipoClienteRevisao, tipoClienteTituloVencido } from '../tipo';
import { AtividadeFilterTipoOption } from './atividade-filter-tipo-option';
import { Cidade } from '../../cidade';

/** Representa o Filter da entidade Atividade */
export class AtividadeFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    setores: number[];
    visibilidade: number;
    idsUsuariosDestino: number[] = [];

    /** Tipos */
    /** Opção do filtro dos tipos de atividades */
    tipoOption = AtividadeFilterTipoOption.Default;
    tipos: number[] = [];
    comTipoEntrarEmContato = false;
    comTipoVisitar = false;
    comTipoTarefa = false;
    comTipoClienteNovo = false;
    comTipoClientePreInativo = false;
    comTipoClienteInativo = false;
    comTipoClienteRevisao = false;
    comTipoClienteTituloVencido = false;

    modo: number;
    // semanaAtual: IntervaloSemana;

    // Cliente
    idsClientes: number[] = [];
    idsClientesTipos: number[] = [];
    idsItensTiposClientes: number[] = [];
    idsEstadosClientes: number[] = [];
    idCidadeCliente: number;
    cidadeCliente: Cidade;
    idsCidadesSubRegioesClientes: number[] = [];
    idsCidadesSubRegioesBairrosClientes: number[] = [];

    origens: number[] = [];
    sinalizado: boolean;
    importante: boolean;
    anoPrazo: number;
    diaPrazoInicial: Date;
    diaPrazoFinal: Date;
    concluida: boolean;
    idsLeads: number[] = [];
    idsNegocios: number[] = [];
    idFunilVenda: number;

    idsRepresentantes: number[] = [];
    idsGerentes: number[] = [];
    idsAtendentes: number[] = [];

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Setores
        if (this.setores) {
            this.setores.forEach(setor => {
                params = params.append('setor', setor.toString());
            });
        }

        // Visibilidade
        if (this.visibilidade != null && this.visibilidade !== undefined) {
            params = params.append('visibilidade', this.visibilidade.toString());
        }

        // Usuários destino
        if (this.idsUsuariosDestino) {
            this.idsUsuariosDestino.forEach(idUsuarioDestino => {
                params = params.append('idUsuarioDestino', idUsuarioDestino.toString());
            });
        }

        /** Tipos */
        if (this.tipoOption != null && this.tipoOption !== undefined) {
            params = params.append('tipoOption', this.tipoOption.toString());
        }
        if (this.tipos) {
            this.tipos.forEach(tipo => {
                params = params.append('tipo', tipo.toString());
            });
        }
        // Tipo Entrar em Contato
        if (this.comTipoEntrarEmContato) {
            params = params.append('tipo', tipoEntrarEmContato.id.toString());
        }
        // Tipo Visitar
        if (this.comTipoVisitar) {
            params = params.append('tipo', tipoVisitar.id.toString());
        }
        // Tipo Tarefa
        if (this.comTipoTarefa) {
            params = params.append('tipo', tipoTarefa.id.toString());
        }
        // Tipo Cliente Novo
        if (this.comTipoClienteNovo) {
            params = params.append('tipo', tipoClienteNovo.id.toString());
        }
        // Tipo Cliente Pré-Inativio
        if (this.comTipoClientePreInativo) {
            params = params.append('tipo', tipoClientePreInativo.id.toString());
        }
        // Tipo Cliente Inativo
        if (this.comTipoClienteInativo) {
            params = params.append('tipo', tipoClienteInativo.id.toString());
        }
        // Tipo Cliente Revisão
        if (this.comTipoClienteRevisao) {
            params = params.append('tipo', tipoClienteRevisao.id.toString());
        }
        // Tipo Cliente Título Vencido
        if (this.comTipoClienteTituloVencido) {
            params = params.append('tipo', tipoClienteTituloVencido.id.toString());
        }

        // Origens
        if (this.origens) {
            this.origens.forEach(origem => {
                params = params.append('origem', origem.toString());
            });
        }

        // Clientes
        if (this.idsClientes) {
            this.idsClientes.forEach(idCliente => {
                params = params.append('idCliente', idCliente.toString());
            });
        }
        // Tipo de cliente
        if (this.idsClientesTipos && this.idsClientesTipos.length > 0) {
            this.idsClientesTipos.forEach(idClienteTipo => {
                params = params.append('idClienteTipo', idClienteTipo.toString());
            });
        }
        // Tipos de itens dos clientes
        if (this.idsItensTiposClientes?.length > 0) {
            this.idsItensTiposClientes.forEach(idItemTipoCliente => {
                params = params.append('idItemTipoCliente', idItemTipoCliente.toString());
            });
        }
        // Estados dos clientes
        if (this.idsEstadosClientes?.length > 0) {
            this.idsEstadosClientes.forEach(idEstadoCliente => {
                params = params.append('idEstadoCliente', idEstadoCliente.toString());
            });
        }
        // Cidades dos clientes
        if (this.idCidadeCliente) {
            params = params.append('idCidadeCliente', this.idCidadeCliente.toString());
        }
        // Subregiões das cidades dos clientes
        if (this.idsCidadesSubRegioesClientes?.length > 0) {
            this.idsCidadesSubRegioesClientes.forEach(idCidadeSubRegiaoCliente => {
                params = params.append('idCidadeSubRegiaoCliente', idCidadeSubRegiaoCliente.toString());
            });
        }
        // Bairros das subregiões das cidades dos clientes
        if (this.idsCidadesSubRegioesBairrosClientes?.length > 0) {
            this.idsCidadesSubRegioesBairrosClientes.forEach(idCidadeSubRegiaoBairroCliente => {
                params = params.append('idCidadeSubRegiaoBairroCliente', idCidadeSubRegiaoBairroCliente.toString());
            });
        }

        // Sinalizado
        if (this.sinalizado) {
            params = params.append('sinalizado', this.sinalizado.toString());
        }
        // Importante
        if (this.importante) {
            params = params.append('importante', this.importante.toString());
        }
        // Ano Prazo
        if (this.anoPrazo) {
            params = params.append('anoPrazo', this.anoPrazo.toString());
        }
        // Data prazo
        if (this.diaPrazoInicial) {
            params = params.append('diaPrazoInicial', toHTTPParam(this.diaPrazoInicial));
        }
        if (this.diaPrazoFinal) {
            params = params.append('diaPrazoFinal', toHTTPParam(this.diaPrazoFinal));
        }
        // Concluída
        if (this.concluida != null && this.concluida !== undefined) {
            params = params.append('concluida', this.concluida.toString());
        }

        // Leads
        if (this.idsLeads) {
            this.idsLeads.forEach(idLead => {
                params = params.append('idLead', idLead.toString());
            });
        }

        // Negócios
        if (this.idsNegocios) {
            this.idsNegocios.forEach(idNegocio => {
                params = params.append('idNegocio', idNegocio.toString());
            });
        }


        // Funil de Vendas
        if (this.idFunilVenda) {
            params = params.append('idFunilVenda', this.idFunilVenda.toString());
        }
        // Representantes
        if (this.idsRepresentantes && this.idsRepresentantes.length > 0) {
            this.idsRepresentantes.forEach(id => {
                params = params.append('idRepresentante', id.toString());
            });
        }
        // Gerentes
        if (this.idsGerentes && this.idsGerentes.length > 0) {
            this.idsGerentes.forEach(id => {
                params = params.append('idGerente', id.toString());
            });
        }
        // Atendentes
        if (this.idsAtendentes && this.idsAtendentes.length > 0) {
            this.idsAtendentes.forEach(id => {
                params = params.append('idAtendente', id.toString());
            });
        }

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.setores = [];
        this.visibilidade = null;
        this.idsUsuariosDestino = [];

        /** Tipos */
        this.tipos = [];
        this.comTipoEntrarEmContato = false;
        this.comTipoVisitar = false;
        this.comTipoTarefa = false;
        this.comTipoClienteNovo =  false;
        this.comTipoClientePreInativo = false;
        this.comTipoClienteInativo = false;
        this.comTipoClienteRevisao = false;
        this.comTipoClienteTituloVencido = false;

        // Clientes
        this.idsClientes = [];
        this.idsClientesTipos = [];
        this.idsItensTiposClientes = [];
        this.idsEstadosClientes = [];
        this.idCidadeCliente = null;
        this.cidadeCliente = null;
        this.idsCidadesSubRegioesClientes = [];
        this.idsCidadesSubRegioesBairrosClientes = [];

        this.origens = [];
        this.sinalizado = false;
        this.importante = false;
        this.anoPrazo = null;
        this.diaPrazoInicial = null;
        this.diaPrazoFinal = null;
        this.concluida = false;
        this.idsLeads = [];
        this.idsNegocios = [];
        this.idFunilVenda = null;
        this.idsRepresentantes = [];
        this.idsGerentes = [];
        this.idsAtendentes = [];
    }

    /** Seta o filtro da visibilidade para minhas atividades */
    setVisibilidadeMinhas() {
        this.visibilidade = visibilidadeMinhas.id;
    }

    /** Seta o filtro da visibilidade para atividades criadas por mim */
    setVisibilidadeCriadasPorMim() {
        this.visibilidade = visibilidadeCriadasPorMim.id;
    }

    /** Seta o filtro da visibilidade para todas atividades */
    setVisibilidadeTodas() {
        this.visibilidade = visibilidadeTodas.id;
    }
}

